<form [formGroup]="form" (ngSubmit)="onSubmit()">

  <h5 mat-dialog-title>{{ title }}</h5>


  <mat-dialog-content>
    <div class="form-group" [class.form-error]="!form.controls['civilite'].valid">
      <label for="civilite">{{ 'general.civilite' | translate }} : <span class="star">*</span></label>
      <mat-select class="form-control" formControlName="civilite" id="civilite">
        <mat-option [value]="'M'">{{ 'general.monsieur' | translate }}</mat-option>
        <mat-option [value]="'F'">{{ 'general.madame' | translate }}</mat-option>
      </mat-select>
    </div>
    <div class="row">
      <div class="col">
        <div class="form-group" [class.form-error]="!form.controls['nom'].valid">
          <label for="nom">{{ 'general.personne.nom' | translate }}: <span class="star">*</span></label>
          <input id="nom" class="form-control" formControlName="nom">
          <app-controls-messages [control]="form.controls['nom']"></app-controls-messages>
        </div>
      </div>
      <div class="col">
        <div class="form-group" [class.form-error]="!form.controls['prenom'].valid">
          <label for="prenom">{{ 'general.prenom' | translate }} :  <span class="star">*</span></label>
          <input id="prenom" class="form-control" formControlName="prenom">
          <app-controls-messages [control]="form.controls['prenom']"></app-controls-messages>
        </div>
      </div>
    </div>
    <div class="form-group" [class.form-error]="!form.controls['email'].valid">
      <label for="email">Email : <span class="star">*</span></label>
      <input id="email" class="form-control" formControlName="email" type="email" required>
      <app-controls-messages [control]="form.controls['email']"></app-controls-messages>
    </div>


    @if (!contactAAP) {
      <div class="form-group" [class.form-error]="!form.controls['contact'].valid">
        <label for="contact">{{ 'general.objet' | translate }} : <span class="star">*</span></label>
        <mat-select class="form-control" formControlName="contact" id="contact" required>
          <mat-option value=""></mat-option>
          @for (contact of contacts; track contact) {
            <mat-option [value]="contact['@id']">{{ contact.label }}</mat-option>
          }
        </mat-select>
        <app-controls-messages [control]="form.controls['contact']"></app-controls-messages>
      </div>
    }

    <div class="form-group" [class.form-error]="!form.controls['message'].valid">
      <label for="message">{{ 'general.message' | translate }} : <span class="star">*</span></label>
      <textarea id="message" class="form-control" formControlName="message" required
      rows="10"></textarea>
      <app-controls-messages [control]="form.controls['message']"></app-controls-messages>
    </div>
  </mat-dialog-content>


  <mat-dialog-actions>
    <button mat-button type="button" [mat-dialog-close]="false">{{ 'general.annuler' |translate}}</button>
    <button mat-raised-button color="primary" type="submit"
    [disabled]="!form.valid">{{ 'general.send' | translate }}</button>
  </mat-dialog-actions>

</form>
